import { createTheme, ThemeOptions } from "@mui/material/styles";

const defaultTheme: ThemeOptions = {
  typography: {
    button: {
      textTransform: "none",
    },
  },
};

const customColors = {
  medium: '#BA80DF',
  mediumGrey: '#241F2D',
  darkGrey: '#45404C',
};

export const darkTheme = createTheme({
  palette: {
    mode: "dark",
    ...customColors
  },
  ...defaultTheme,
});

export const lightTheme = createTheme({
  palette: {
    mode: "light",
    ...customColors
  },
  ...defaultTheme,
});
